import _ from "lodash";

export const LIST_CONFIG_MODULES = Object.freeze({
  ORCAMENTO: 4,
  ORDEM_SERVICO: 5,
  PEDIDOS: 8,
  NFCE: 13,
  NFE: 14,
});

export function createColumnVisibilityMixin({ moduleConfig, sidebarId }) {
  return {
    data() {
      return {
        id_configuracao_lista: null,
        fieldsToShow: [],
      };
    },
    computed: {
      columnSidebarId() {
        return sidebarId;
      },
    },
    async created() {
      this.fieldsToShow = _.cloneDeep(this.fields);

      try {
        const { data } = await this.$http.post("/configuracao-lista/find", {
          modulo: moduleConfig,
        });

        this.id_configuracao_lista = data?.id_configuracao_lista ?? null;

        if (data?.lista?.length > 0) {
          this.fieldsToShow = this.normalizeFieldsToShow(data.lista);
        }
      } catch (error) {
        if (error?.response?.data?.msg) {
          this.$toast.error(error.response.data.msg);
        }
      }
    },
    methods: {
      normalizeFieldsToShow(fields) {
        const selectedFields = new Set(fields.map((field) => field.field));

        return this.normalizeVisibleWidths(
          _.cloneDeep(
            this.fields.filter(
              (field) =>
                selectedFields.has(field.field) || field.field === "actions"
            )
          )
        );
      },
      normalizeVisibleWidths(fields) {
        const actionsField = fields.find((field) => field.field === "actions");
        const actionsWidth = actionsField?.width?.includes("%")
          ? parseFloat(actionsField.width)
          : 20;
        const availableWidth = 100 - actionsWidth;
        const informationFields = fields.filter(
          (field) => field.field !== "actions"
        );
        const weightedFields = informationFields
          .map((field) => ({
            field,
            width: field.width?.includes("%") ? parseFloat(field.width) : 1,
          }))
          .filter(({ width }) => !Number.isNaN(width));
        const totalWidth = weightedFields.reduce(
          (total, { width }) => total + width,
          0
        );

        if (!totalWidth || totalWidth >= availableWidth) {
          return fields;
        }

        return fields.map((field) => {
          if (field.field === "actions") {
            return {
              ...field,
              width: field.width || `${actionsWidth}%`,
            };
          }

          const weightedField = weightedFields.find(
            ({ field: currentField }) => currentField.field === field.field
          );

          if (!weightedField) {
            return field;
          }

          return {
            ...field,
            width: `${(weightedField.width / totalWidth) * availableWidth}%`,
          };
        });
      },
      getFieldsToSave(fields) {
        const selectedFields = new Set(fields.map((field) => field.field));

        return _.cloneDeep(
          this.fields.filter(
            (field) =>
              selectedFields.has(field.field) || field.field === "actions"
          )
        );
      },
      async handleSaveFields(selectedFields) {
        const fieldsToSave = this.getFieldsToSave(selectedFields);

        try {
          const { data } = await this.$http.post(
            this.id_configuracao_lista
              ? "/configuracao-lista/update"
              : "/configuracao-lista/create",
            {
              ...(this.id_configuracao_lista && {
                id_configuracao_lista: this.id_configuracao_lista,
              }),
              modulo: moduleConfig,
              lista: fieldsToSave,
            }
          );

          this.$toast.success(data.msg);
          this.fieldsToShow = this.normalizeVisibleWidths(
            _.cloneDeep(fieldsToSave)
          );

          if (!this.id_configuracao_lista) {
            this.id_configuracao_lista = data.data.id_configuracao_lista;
          }
        } catch (error) {
          this.$toast.error(
            error?.response?.data?.msg || "Erro ao salvar colunas"
          );
        }

        this.$root.$emit("bv::toggle::collapse", this.columnSidebarId);
      },
    },
  };
}
